export const YANDEX_DZEN_TITLE_CONSTS = {
  maxErrorMessage: 'Достигнут лимит по кол-ву символов',
  maxWarningMessage: 'Слишком длинный заголовок!',
  fieldIsRequiredMsg: 'Поле обязательно к заполнению'
}
